// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActionFiringMode } from "./action-firing-mode";
import { OrgStatus } from "./org-status";
import { OrgType } from "./org-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Full organization record matching the `organizations` `PostgreSQL` table.
 */
export class Organization implements flatbuffers.IUnpackableObject<OrganizationT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Organization {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOrganization(bb: flatbuffers.ByteBuffer, obj?: Organization): Organization {
    return (obj || new Organization()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsOrganization(
    bb: flatbuffers.ByteBuffer,
    obj?: Organization,
  ): Organization {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Organization()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  address(): string | null;
  address(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  address(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  city(): string | null;
  city(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  city(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  country(): string | null;
  country(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  country(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  phoneCode(): string | null;
  phoneCode(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  phoneCode(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  phone(): string | null;
  phone(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  phone(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  state(): string | null;
  state(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  state(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  parentId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  type(): OrgType {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : OrgType.ORG;
  }

  status(): OrgStatus {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : OrgStatus.ACTIVE;
  }

  doorUnknownAsOpening(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  hideUnconfiguredDoors(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Direct child organizations (populated when fetching a single org by ID).
   */
  children(index: number, obj?: Organization): Organization | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset
      ? (obj || new Organization()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  childrenLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * How this organization dispatches control commands that target a floor.
   *
   * The site-wide default. An organization never stores INHERIT -- there is
   * nothing above it to inherit from -- and TWO_STEP is the default because
   * it is the behaviour that cannot send a command at a floor nobody chose.
   * A user may override it; see User.action_firing_mode.
   */
  actionFiringMode(): ActionFiringMode {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActionFiringMode.TWO_STEP;
  }

  static startOrganization(builder: flatbuffers.Builder) {
    builder.startObject(18);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addAddress(builder: flatbuffers.Builder, addressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, addressOffset, 0);
  }

  static addCity(builder: flatbuffers.Builder, cityOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, cityOffset, 0);
  }

  static addCountry(builder: flatbuffers.Builder, countryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, countryOffset, 0);
  }

  static addPhoneCode(builder: flatbuffers.Builder, phoneCodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, phoneCodeOffset, 0);
  }

  static addPhone(builder: flatbuffers.Builder, phoneOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, phoneOffset, 0);
  }

  static addState(builder: flatbuffers.Builder, stateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, stateOffset, 0);
  }

  static addParentId(builder: flatbuffers.Builder, parentIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, parentIdOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: OrgType) {
    builder.addFieldInt8(9, type, OrgType.ORG);
  }

  static addStatus(builder: flatbuffers.Builder, status: OrgStatus) {
    builder.addFieldInt8(10, status, OrgStatus.ACTIVE);
  }

  static addDoorUnknownAsOpening(builder: flatbuffers.Builder, doorUnknownAsOpening: boolean) {
    builder.addFieldInt8(11, +doorUnknownAsOpening, +false);
  }

  static addHideUnconfiguredDoors(builder: flatbuffers.Builder, hideUnconfiguredDoors: boolean) {
    builder.addFieldInt8(12, +hideUnconfiguredDoors, +true);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, deletedAtOffset, 0);
  }

  static addChildren(builder: flatbuffers.Builder, childrenOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, childrenOffset, 0);
  }

  static createChildrenVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startChildrenVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActionFiringMode(builder: flatbuffers.Builder, actionFiringMode: ActionFiringMode) {
    builder.addFieldInt8(17, actionFiringMode, ActionFiringMode.TWO_STEP);
  }

  static endOrganization(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // name
    return offset;
  }

  unpack(): OrganizationT {
    return new OrganizationT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.address(),
      this.city(),
      this.country(),
      this.phoneCode(),
      this.phone(),
      this.state(),
      this.parentId() !== null ? this.parentId()!.unpack() : null,
      this.type(),
      this.status(),
      this.doorUnknownAsOpening(),
      this.hideUnconfiguredDoors(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<Organization, OrganizationT>(
        this.children.bind(this),
        this.childrenLength(),
      ),
      this.actionFiringMode(),
    );
  }

  unpackTo(_o: OrganizationT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.address = this.address();
    _o.city = this.city();
    _o.country = this.country();
    _o.phoneCode = this.phoneCode();
    _o.phone = this.phone();
    _o.state = this.state();
    _o.parentId = this.parentId() !== null ? this.parentId()!.unpack() : null;
    _o.type = this.type();
    _o.status = this.status();
    _o.doorUnknownAsOpening = this.doorUnknownAsOpening();
    _o.hideUnconfiguredDoors = this.hideUnconfiguredDoors();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.children = this.bb!.createObjList<Organization, OrganizationT>(
      this.children.bind(this),
      this.childrenLength(),
    );
    _o.actionFiringMode = this.actionFiringMode();
  }

  unpackFields(...fields: string[]): OrganizationT {
    const t = new OrganizationT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("address")) {
      t.address = this.address();
    }
    if (fieldSet.has("city")) {
      t.city = this.city();
    }
    if (fieldSet.has("country")) {
      t.country = this.country();
    }
    if (fieldSet.has("phone_code")) {
      t.phoneCode = this.phoneCode();
    }
    if (fieldSet.has("phone")) {
      t.phone = this.phone();
    }
    if (fieldSet.has("state")) {
      t.state = this.state();
    }
    if (fieldSet.has("parent_id")) {
      t.parentId = this.parentId() !== null ? this.parentId()!.unpack() : null;
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("status")) {
      t.status = this.status();
    }
    if (fieldSet.has("door_unknown_as_opening")) {
      t.doorUnknownAsOpening = this.doorUnknownAsOpening();
    }
    if (fieldSet.has("hide_unconfigured_doors")) {
      t.hideUnconfiguredDoors = this.hideUnconfiguredDoors();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("children")) {
      t.children = this.bb!.createObjList<Organization, OrganizationT>(
        this.children.bind(this),
        this.childrenLength(),
      );
    }
    if (fieldSet.has("action_firing_mode")) {
      t.actionFiringMode = this.actionFiringMode();
    }
    return t;
  }
}

export class OrganizationT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public address: string | Uint8Array | null = null,
    public city: string | Uint8Array | null = null,
    public country: string | Uint8Array | null = null,
    public phoneCode: string | Uint8Array | null = null,
    public phone: string | Uint8Array | null = null,
    public state: string | Uint8Array | null = null,
    public parentId: UuidT | null = null,
    public type: OrgType = OrgType.ORG,
    public status: OrgStatus = OrgStatus.ACTIVE,
    public doorUnknownAsOpening: boolean = false,
    public hideUnconfiguredDoors: boolean = true,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public children: OrganizationT[] = [],
    public actionFiringMode: ActionFiringMode = ActionFiringMode.TWO_STEP,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const address = this.address !== null ? builder.createString(this.address!) : 0;
    const city = this.city !== null ? builder.createString(this.city!) : 0;
    const country = this.country !== null ? builder.createString(this.country!) : 0;
    const phoneCode = this.phoneCode !== null ? builder.createString(this.phoneCode!) : 0;
    const phone = this.phone !== null ? builder.createString(this.phone!) : 0;
    const state = this.state !== null ? builder.createString(this.state!) : 0;
    const parentId = this.parentId !== null ? this.parentId!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const children = Organization.createChildrenVector(
      builder,
      builder.createObjectOffsetList(this.children),
    );

    Organization.startOrganization(builder);
    Organization.addId(builder, id);
    Organization.addName(builder, name);
    Organization.addAddress(builder, address);
    Organization.addCity(builder, city);
    Organization.addCountry(builder, country);
    Organization.addPhoneCode(builder, phoneCode);
    Organization.addPhone(builder, phone);
    Organization.addState(builder, state);
    Organization.addParentId(builder, parentId);
    Organization.addType(builder, this.type);
    Organization.addStatus(builder, this.status);
    Organization.addDoorUnknownAsOpening(builder, this.doorUnknownAsOpening);
    Organization.addHideUnconfiguredDoors(builder, this.hideUnconfiguredDoors);
    Organization.addCreatedAt(builder, createdAt);
    Organization.addUpdatedAt(builder, updatedAt);
    Organization.addDeletedAt(builder, deletedAt);
    Organization.addChildren(builder, children);
    Organization.addActionFiringMode(builder, this.actionFiringMode);

    return Organization.endOrganization(builder);
  }

  clone(): OrganizationT {
    const obj = new OrganizationT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.address = this.address;
    obj.city = this.city;
    obj.country = this.country;
    obj.phoneCode = this.phoneCode;
    obj.phone = this.phone;
    obj.state = this.state;
    obj.parentId = this.parentId !== null ? this.parentId!.clone() : null;
    obj.type = this.type;
    obj.status = this.status;
    obj.doorUnknownAsOpening = this.doorUnknownAsOpening;
    obj.hideUnconfiguredDoors = this.hideUnconfiguredDoors;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.children = this.children.map((e) => e.clone());
    obj.actionFiringMode = this.actionFiringMode;
    return obj;
  }

  equals(other: OrganizationT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.address !== other.address) return false;
    if (this.city !== other.city) return false;
    if (this.country !== other.country) return false;
    if (this.phoneCode !== other.phoneCode) return false;
    if (this.phone !== other.phone) return false;
    if (this.state !== other.state) return false;
    if (this.parentId !== null && other.parentId !== null) {
      if (!this.parentId!.equals(other.parentId!)) return false;
    } else if (this.parentId !== other.parentId) return false;
    if (this.type !== other.type) return false;
    if (this.status !== other.status) return false;
    if (this.doorUnknownAsOpening !== other.doorUnknownAsOpening) return false;
    if (this.hideUnconfiguredDoors !== other.hideUnconfiguredDoors) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.children.length !== other.children.length) return false;
    for (let i = 0; i < this.children.length; i++) {
      const a = this.children[i];
      const b = other.children[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.actionFiringMode !== other.actionFiringMode) return false;
    return true;
  }
}

export function verifyOrganization(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 20);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 22, 1);
    verifier.checkScalarField(tablePos, 24, 1);
    verifier.checkScalarField(tablePos, 26, 1);
    verifier.checkScalarField(tablePos, 28, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyOrganization);
      }
    }
    verifier.checkScalarField(tablePos, 38, 1);
  } finally {
    verifier.popDepth();
  }
}
